import React from 'react';
import Fab from '@material-ui/core/Fab';
import Tooltip from '@material-ui/core/Tooltip';
import EditIcon from '@material-ui/icons/Edit';
import CloseIcon from '@material-ui/icons/Close';

import * as utils from "../../basics/utils";

export const Icon = ({ type, width = 0, height = 0, className = '', color = "#6B6B6B" }) => {

    const getImage = () => {

        const worldSVG = () => {
            // assets/images/LMH_SVG/dark-grey/LMH_Icons_world_dg.svg'
            return (
                <svg width={width} height={height} className={className} viewBox="0 0 32 32">
                    <path fill={color} d="M16,2C8.28,2,2,8.28,2,16s6.28,14,14,14s14-6.28,14-14S23.72,2,16,2z M10.024,15H4.041
                        c0.174-2.103,0.9-4.049,2.022-5.706c1.284,0.534,2.796,0.94,4.409,1.225C10.221,11.961,10.071,13.477,10.024,15z M12.426,10.797
                        C13.604,10.927,14.806,11,16,11c1.194,0,2.396-0.073,3.574-0.202c0.218,1.253,0.362,2.66,0.407,4.202H12.02
                        C12.064,13.457,12.208,12.05,12.426,10.797z M10.024,17c0.046,1.522,0.197,3.038,0.448,4.48c-1.615,0.286-3.122,0.696-4.406,1.23
                        C4.943,21.052,4.216,19.105,4.041,17H10.024z M12.02,17h7.961c-0.045,1.543-0.189,2.95-0.407,4.203C18.396,21.073,17.194,21,16,21
                        s-2.396,0.073-3.574,0.203C12.208,19.95,12.064,18.543,12.02,17z M21.976,17h5.983c-0.174,2.105-0.902,4.052-2.025,5.71
                        c-1.285-0.534-2.791-0.945-4.406-1.23C21.779,20.038,21.929,18.522,21.976,17z M21.976,15c-0.046-1.523-0.197-3.039-0.449-4.481
                        c1.614-0.285,3.125-0.691,4.409-1.225c1.122,1.657,1.848,3.603,2.023,5.706H21.976z M24.621,7.674
                        c-0.978,0.363-2.152,0.676-3.506,0.908c-0.397-1.552-0.918-2.95-1.573-4.047C21.497,5.14,23.233,6.238,24.621,7.674z M16,4
                        c1.034,0,2.32,1.754,3.15,4.852C18.169,8.947,17.118,9,16,9c-1.118,0-2.168-0.054-3.15-0.15C13.68,5.753,14.966,4,16,4z
                        M12.457,4.535c-0.655,1.098-1.176,2.496-1.573,4.048C9.531,8.35,8.356,8.037,7.378,7.675C8.766,6.238,10.502,5.14,12.457,4.535z
                        M7.374,24.321c0.978-0.362,2.158-0.673,3.51-0.904c0.397,1.552,0.918,2.951,1.573,4.049C10.5,26.859,8.763,25.76,7.374,24.321z
                        M16,28c-1.034,0-2.319-1.753-3.149-4.849C13.833,23.055,14.881,23,16,23s2.167,0.055,3.149,0.151C18.319,26.247,17.034,28,16,28z
                        M19.543,27.465c0.655-1.098,1.177-2.496,1.573-4.049c1.352,0.231,2.532,0.543,3.51,0.904C23.237,25.76,21.5,26.859,19.543,27.465z
                        "/>
                </svg>
            )
        }

        const shareSVG = () => {
            // assets/images/LMH_SVG/dark-grey/LMH_Icons_share_dg.svg'
            return (
                <svg width={width} height={height} className={className} viewBox="0 0 32 32">
                    <polygon fill={color} points="28,26 4,26 4,10 12,10 12,8 2,8 2,28 30,28 30,15 28,15 	" />
                    <path fill={color} d="M16,13c0-1.654,1.346-3,3-3h7.586l-3.293,3.293l1.414,1.414L30.414,9l-5.707-5.707l-1.414,1.414
                        L26.586,8H19c-2.757,0-5,2.243-5,5v5h2V13z"/>
                </svg>
            )
        }

        const deleteSVG = () => {
            // assets/images/LMH_SVG/dark-grey/LMH_Icons_delete_dg.svg'
            return (
                <svg width={width} height={height} className={className} viewBox="0 0 32 32">
                    <path fill={color} d="M29,6h-6.4l-2-4h-9.2l-2,4H3v2h2l2,22h18l2-22h2V6z M12.6,4h6.8l1,2h-8.8L12.6,4z M23,28H9L7,8h18L23,28z" />
                    <rect x="11" y="12" fill={color} width="2" height="12" />
                    <rect x="15" y="12" fill={color} width="2" height="12" />
                    <rect x="19" y="12" fill={color} width="2" height="12" />
                </svg>
            )
        }
        const euroSVG = () => {
            // assets/images/LMH_SVG/dark-grey/LMH_Icons_euro_dg.svg'
            return (
                <svg width={width} height={height} className={className} viewBox="0 0 32 32">
                    <path fill="rgb(221,76,70)" d="M16,2C8.28,2,2,8.28,2,16s6.28,14,14,14s14-6.28,14-14S23.72,2,16,2z M16,28C9.383,28,4,22.617,4,16
                        S9.383,4,16,4s12,5.383,12,12S22.617,28,16,28z"/>
                    <path fill="rgb(221,76,70)" d="M14.129,12.462c0.459-0.46,0.995-0.82,1.59-1.072c1.231-0.521,2.66-0.521,3.892,0l0.779-1.842
                        c-1.728-0.73-3.723-0.73-5.45,0c-0.833,0.353-1.582,0.857-2.224,1.5c-0.643,0.642-1.147,1.39-1.5,2.224
                        c-0.235,0.556-0.387,1.134-0.471,1.726H9v2h1.744c0.085,0.591,0.237,1.17,0.471,1.726c0.353,0.834,0.857,1.582,1.5,2.224
                        c0.643,0.643,1.391,1.147,2.225,1.5c0.864,0.365,1.78,0.551,2.725,0.551s1.861-0.186,2.725-0.551l-0.779-1.842
                        c-1.231,0.521-2.66,0.521-3.892,0c-0.595-0.252-1.13-0.612-1.59-1.072c-0.459-0.459-0.819-0.993-1.071-1.589
                        c-0.129-0.307-0.227-0.623-0.292-0.946H19v-2h-6.235c0.066-0.323,0.163-0.64,0.292-0.946
                        C13.309,13.455,13.669,12.921,14.129,12.462z"/>
                </svg>
            )
        }
        const starFilledSVG = () => {
            // assets/images/LMH_SVG/dark-grey/LMH_Icons_star_filled_dg.svg'
            return (
                <svg width={width} height={height} className={className} viewBox="0 0 32 32">
                    <path fill={color} d="M23.59,27.442L16,22.871l-7.59,4.571c-0.299,0.18-0.668-0.085-0.591-0.424l1.962-8.705
                        l-6.647-5.869c-0.26-0.229-0.119-0.656,0.227-0.688l8.791-0.804l3.484-8.212c0.136-0.321,0.593-0.321,0.73,0l3.484,8.212
                        l8.791,0.804c0.345,0.032,0.486,0.459,0.227,0.688l-6.647,5.869l1.962,8.705C24.258,27.357,23.889,27.622,23.59,27.442z"/>
                </svg>
            )
        }

        const starSpikesSVG = () => {
            // assets/images/LMH_SVG/dark-grey/LMH_Icons_star_spikes_dg.svg'
            return (
                <svg width={width} height={height} className={className} viewBox="0 0 32 32">
                    <path fill={color} d="M23.597,27.434L16,22.859l-7.597,4.575c-0.294,0.177-0.658-0.084-0.583-0.418l1.964-8.713
                        l-6.653-5.874c-0.256-0.226-0.117-0.646,0.223-0.678l8.799-0.805l3.487-8.219c0.134-0.316,0.584-0.316,0.719,0l3.487,8.219
                        l8.799,0.805c0.34,0.031,0.479,0.452,0.223,0.678l-6.653,5.874l1.964,8.713C24.255,27.35,23.891,27.611,23.597,27.434z M16,20.576
                        l5.458,3.286l-1.411-6.256l4.802-4.239l-6.353-0.581L16,6.901l-2.497,5.884l-6.353,0.581l4.802,4.239l-1.411,6.256L16,20.576z"/>
                </svg>
            )
        }

        const settingsSVG = () => {
            // assets/images/LMH_SVG/dark-grey/LMH_Icons_ettings_dg.svg'
            return (
                <svg width={width} height={height} className={className} viewBox="0 0 32 32">
                    <path fill={color} d="M16,9c-3.86,0-7,3.141-7,7s3.14,7,7,7s7-3.141,7-7S19.86,9,16,9z M16,21c-2.757,0-5-2.243-5-5
                        s2.243-5,5-5s5,2.243,5,5S18.757,21,16,21z"/>
                    <path fill={color} d="M29.927,14.657c-0.104-0.974-0.883-1.729-1.851-1.797l-1.039-0.075
                        c-0.234-0.804-0.556-1.578-0.962-2.314l0.684-0.789c0.639-0.739,0.661-1.814,0.052-2.556c-0.578-0.704-1.23-1.355-1.938-1.939
                        c-0.715-0.585-1.847-0.561-2.555,0.055l-0.789,0.684c-0.737-0.406-1.512-0.729-2.315-0.963L19.14,3.924
                        c-0.069-0.969-0.825-1.747-1.798-1.851c-0.929-0.1-1.754-0.1-2.684,0c-0.973,0.104-1.729,0.882-1.798,1.851l-0.074,1.038
                        c-0.803,0.234-1.578,0.557-2.315,0.963L9.682,5.241C8.974,4.626,7.843,4.6,7.125,5.188C6.418,5.771,5.767,6.422,5.188,7.126
                        C4.58,7.867,4.602,8.942,5.242,9.683l0.683,0.788c-0.406,0.736-0.728,1.511-0.962,2.314l-1.037,0.074
                        c-0.97,0.068-1.75,0.824-1.853,1.798C2.024,15.125,2,15.563,2,16c0,0.436,0.024,0.874,0.073,1.342
                        c0.104,0.973,0.882,1.729,1.852,1.798l1.038,0.074c0.234,0.803,0.556,1.577,0.962,2.314l-0.684,0.789
                        c-0.641,0.739-0.663,1.814-0.053,2.556c0.581,0.707,1.233,1.359,1.938,1.939c0.716,0.588,1.849,0.558,2.555-0.055l0.789-0.684
                        c0.737,0.406,1.512,0.729,2.315,0.963l0.074,1.038c0.069,0.969,0.825,1.747,1.798,1.851C15.129,29.976,15.568,30,16,30
                        s0.871-0.024,1.342-0.074c0.973-0.104,1.729-0.882,1.798-1.851l0.074-1.038c0.803-0.234,1.578-0.557,2.315-0.963l0.787,0.683
                        c0.709,0.617,1.84,0.644,2.557,0.055c0.705-0.579,1.357-1.231,1.938-1.938c0.611-0.742,0.588-1.817-0.052-2.557l-0.684-0.789
                        c0.406-0.737,0.728-1.512,0.962-2.314l1.039-0.074c0.969-0.069,1.748-0.825,1.851-1.798C29.976,16.874,30,16.436,30,16
                        C30,15.563,29.976,15.125,29.927,14.657z M27.933,17.146l-2.501,0.178l-0.161,0.729c-0.238,1.079-0.664,2.105-1.267,3.049
                        l-0.402,0.629l1.664,1.874c-0.499,0.606-1.058,1.166-1.639,1.643l-1.897-1.644l-0.629,0.401c-0.943,0.603-1.969,1.028-3.048,1.267
                        l-0.729,0.161l-0.192,2.506c-0.744,0.078-1.506,0.083-2.277-0.005l-0.179-2.501l-0.729-0.161c-1.079-0.238-2.105-0.664-3.048-1.267
                        l-0.629-0.401l-1.874,1.664c-0.604-0.497-1.164-1.057-1.643-1.639l1.645-1.898l-0.402-0.629c-0.603-0.943-1.029-1.97-1.267-3.049
                        l-0.161-0.729l-2.506-0.192C4.023,16.76,4,16.383,4,16c0-0.384,0.023-0.761,0.068-1.146l2.5-0.179l0.161-0.729
                        c0.238-1.081,0.665-2.106,1.267-3.049l0.402-0.629L6.733,8.396c0.496-0.604,1.056-1.163,1.639-1.643l1.897,1.644l0.629-0.401
                        c0.943-0.603,1.969-1.028,3.048-1.267l0.729-0.161l0.192-2.506c0.744-0.078,1.506-0.083,2.277,0.005l0.179,2.501l0.729,0.161
                        c1.079,0.238,2.105,0.664,3.048,1.267l0.629,0.401l1.873-1.664c0.608,0.5,1.167,1.06,1.645,1.64l-1.645,1.897l0.402,0.629
                        c0.602,0.942,1.028,1.968,1.267,3.049l0.161,0.729l2.506,0.192C27.977,15.239,28,15.616,28,16
                        C28,16.383,27.977,16.76,27.933,17.146z"/>
                </svg>
            )
        }

        const searchSVG = () => {
            // assets/images/LMH_SVG/light-grey/LMH_Icons_search_lg.svg'
            return (
                <svg width={width} height={height} className={className} viewBox="0 0 32 32">
                    <path fill="#D2D2D2" d="M27.293,22.879l-7.124-7.124C20.697,14.61,21,13.341,21,12c0-4.962-4.038-9-9-9s-9,4.038-9,9
                        s4.038,9,9,9c1.341,0,2.61-0.303,3.755-0.831l7.124,7.124c0.585,0.585,1.353,0.877,2.121,0.877s1.536-0.292,2.121-0.877
                        l0.172-0.172C28.463,25.952,28.463,24.048,27.293,22.879z M5,12c0-3.86,3.14-7,7-7s7,3.14,7,7s-3.14,7-7,7S5,15.86,5,12z
                        M25.879,25.707l-0.172,0.172c-0.39,0.39-1.024,0.39-1.414,0l-6.78-6.78c0.593-0.461,1.125-0.993,1.586-1.586l6.78,6.78
                        C26.269,24.683,26.269,25.317,25.879,25.707z"/>
                </svg>
            )
        }

        const loadCapacitySVG = () => {
            // assets/images/LMH_SVG/dark-grey/LMH_Icons_load_capacity_dg.svg'
            return (
                <svg width={width} height={height} className={className} viewBox="0 0 32 32">
                    <g>
                        <path d="M23.957,8.794l-0.039-0.136C23.693,8.042,22.953,7,21.5,7h-2.566c0.34-0.419,0.566-0.92,0.566-1.5
                            C19.5,3.57,17.93,2,16,2s-3.5,1.57-3.5,3.5c0,0.584,0.193,1.079,0.486,1.5H10.5C9,7,8.263,8.042,8.039,8.658L3.978,28
                            c-0.022,0.144-0.007,0.913,0.432,1.352C4.686,29.627,5.143,30,5.978,30h20c0.835,0,1.292-0.372,1.568-0.648
                            c0.462-0.462,0.432-0.961,0.432-1.352L23.957,8.794z M16,4c0.827,0,1.5,0.673,1.5,1.5S16.827,7,16,7s-1.5-0.673-1.5-1.5
                            S15.173,4,16,4z M6,28L9.936,9.304C9.982,9.214,10.118,9,10.342,9h11.272c0.224,0,0.359,0.215,0.406,0.305L26,28H6z"/>
                        <polygon points="15.707,17 14.293,17 12.5,18.793 12.5,17 11.5,17 11.5,22 12.5,22 12.5,20.207 
                            12.946,19.761 14.625,22 15.875,22 13.66,19.047"/>
                        <path d="M18.5,20H20c-0.141,0.641-0.5,1-1.5,1c-0.827,0-1.5-0.673-1.5-1.5s0.673-1.5,1.5-1.5
                            c0.428,0,0.726,0.211,1,0.5l1.091-0.364C20.144,17.454,19.375,17,18.5,17c-1.378,0-2.5,1.122-2.5,2.5s1.122,2.5,2.5,2.5
                            c1.5,0,2.5-0.969,2.5-2.5V19h-2.5V20z"/>
                    </g>
                </svg>
            )
        }

        const loadHeightSVG = () => {
            // assets/images/LMH_SVG/dark-grey/LMH_Icons_load_height_dg.svg'
            return (
                <svg width={width} height={height} className={className} viewBox="0 0 32 32">
                    <g id="height">
                        <polygon points="21.707,11.707 16,6 10.293,11.707 11.707,13.121 15,9.828 15,26 17,26 17,9.828 20.293,13.121" />
                        <g><rect x="3" y="28" width="26" height="2" /></g>
                        <g><rect x="3" y="2" width="5" height="2" /></g>
                        <g><rect x="24" y="2" width="5" height="2" /></g>
                        <g><rect x="17" y="2" width="5" height="2" /></g>
                        <g><rect x="10" y="2" width="5" height="2" /></g>
                    </g>
                </svg>
            )
        }

        const videoSVG = () => {
            // assets/images/LMH_SVG/dark-grey/LMH_Icons_load_height_dg.svg'
            return (
                <svg width={width} height={height * .6} className={className} viewBox="0 0 489.2 489.2">
                    <path fill="black" d="M439.6,0h-390C22.2,0,0,22.2,0,49.6v390c0,27.4,22.2,49.6,49.6,49.6h390c27.4,0,49.6-22.2,49.6-49.6V49.7   C489.3,22.3,467,0,439.6,0z M300.6,47.8h42.5v42.5h-42.5V47.8z M223.4,47.8h42.5v42.5h-42.5V47.8L223.4,47.8z M146.1,47.8h42.5   v42.5h-42.5V47.8z M111.3,441.6H68.8v-42.5h42.5V441.6z M111.3,90.3H68.8V47.8h42.5V90.3z M188.6,441.6h-42.5v-42.5h42.5V441.6z    M265.8,441.6h-42.5v-42.5h42.5V441.6z M343.1,441.6h-42.5v-42.5h42.5V441.6z M352.5,256.7l-163.1,94.2c-9.2,5.3-20.8-1.3-20.8-12   V150.5c0-10.7,11.6-17.3,20.8-12l163.1,94.2C361.8,238,361.8,251.4,352.5,256.7z M420.4,441.6h-42.5v-42.5h42.5V441.6z M420.4,90.3   h-42.5V47.8h42.5V90.3z" />
                </svg>
            )
        }

        const closeSVG = () => {
            // MaterialUI IconClose
            return (
                <svg width={width} height={height} className={className} viewBox="0 0 24 24">
                    <path fill={color} d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
                </svg>
            )
        }

        const close2SVG = () => {
            // assets/images/LMH_SVG/dark-grey/LMH_Icons_close-cancel_dg.svg
            return (
                <svg width={width} height={height} viewBox="0 0 32 32">
                    <polygon fill={color} points="22.906,10.507 21.492,9.093 16,14.586 10.508,9.093 9.094,10.507 14.586,16 9.094,21.493 
                        10.508,22.907 16,17.414 21.492,22.907 22.906,21.493 17.414,16"/>
                </svg>
            )
        }

        //return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"},"child":[{"tag":"path","attr":{"d":"M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"}},{"tag":"path","attr":{"d":"M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"}}]})(props);

        const edit2SVG = () => {
            // MaterialUI IconDelete

            return (
                <svg width={width} height={height} className={className} viewBox="0 0 24 24">
                    <path fill='none' stroke={color} strokeWidth='1.7' d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                    <path fill='none' stroke={color} strokeWidth='1.7' d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                </svg>
            )
        }

        const editSVG = () => {
            // MaterialUI IconDelete
            return (
                <svg width={width} height={height} className={className} viewBox="0 0 24 24">
                    <path fill={color} d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"></path>
                </svg>
            )
        }

        const filterSVG = () => {
            // assets/images/LMH_SVG/dark-grey/LMH_Icons_filter_dg.svg'
            return (
                <svg width={width} height={height} viewBox="0 0 32 32">
                    <path fill={color} d="M14,28a1,1,0,0,1-1-1V18.3l-7.33-11A1.48,1.48,0,0,1,6.91,5H25.09a1.48,1.48,0,0,1,1.23,2.31L19,18.3V24a1,1,0,0,1-.4.8l-4,3A1,1,0,0,1,14,28ZM7.87,7l7,10.45A1,1,0,0,1,15,18v7l2-1.5V18a1,1,0,0,1,.17-.55L24.13,7Z" />
                </svg>
            )
        }

        const personSVG = () => {
            // assets/images/LMH_SVG/dark-grey/LMH_Icons_person_dg.svg'

            return (
                <svg width={width} height={height} viewBox="0 0 32 32">
                    <path fill={color} d="M16,16c3.309,0,6-2.691,6-6V9c0-3.309-2.691-6-6-6s-6,2.691-6,6v1C10,13.309,12.691,16,16,16z M12,9
                        c0-2.206,1.794-4,4-4s4,1.794,4,4v1c0,2.206-1.794,4-4,4s-4-1.794-4-4V9z"/>
                    <path fill={color} d="M28.36,20.295c-7.912-3.06-16.809-3.06-24.721,0L3,20.542V28h26v-7.458L28.36,20.295z M27,25.998H5
                        v-4.075c7.065-2.563,14.935-2.563,22,0V25.998z"/>
                </svg>
            )
        }
        const openSVG = () => {
            // assets/images/LMH_SVG/dark-grey/LMH_Icons_close-cancel_dg.svg
            return (
                <svg width={width} height={height} viewBox="0 0 32 32">
                    <g>
                        <polygon fill={color} points="24,28 6,28 6,4 20,4 20,2 4,2 4,30 26,30 26,24 24,24 	" />
                        <rect x="8" y="10" fill={color} width="12" height="2" />
                        <polygon fill={color} points="20,6 20,8 26.2,8 23.6,10.6 25,12 30,7 25,2 23.6,3.4 26.2,6 	" />
                        <rect x="8" y="14" fill={color} width="12" height="2" />
                        <rect x="8" y="22" fill={color} width="6" height="2" />
                        <rect x="8" y="18" fill={color} width="6" height="2" />
                        <path fill={color} d="M16,21.8V26h4.2l8.1-8.1l-4.2-4.2L16,21.8z M19.4,24H18v-1.4l6.1-6.1l1.4,1.4L19.4,24z" />
                    </g>
                </svg>
            )
        }

        const leftSVG = () => {
            // assets/images/LMH_SVG/dark-grey/LMH_Icons_left_dg.svg
            return (
                <svg width={width} height={height} viewBox="0 0 32 32">
                    <g>
                        <polygon fill={color} points="18.293,24.707 9.586,16 18.293,7.293 19.707,8.707 12.414,16 19.707,23.293 	" />
                    </g>
                </svg>
            )
        }

        const viewSVG = () => {
            // assets/images/LMH_SVG/dark-grey/LMH_Icons_view_dg.svg
            return (
                <svg width={width} height={height} viewBox="0 0 32 32">
                    <g id="view">
                        <path fill={color} d="M29.849,14.473C29.635,14.127,24.493,6,16,6C7.507,6,2.365,14.127,2.15,14.473L2,14.715v1.57
                            l0.15,0.242C2.365,16.873,7.507,25,16,25c8.494,0,13.635-8.127,13.85-8.473L30,16.285v-1.57L29.849,14.473z M28,15.699
                            C27.14,16.956,22.658,23,16,23c-6.636,0-11.136-6.045-12-7.302v-0.396C4.864,14.045,9.364,8,16,8c6.636,0,11.136,6.045,12,7.302
                            V15.699z"/>
                        <path fill={color} d="M16,10c-3.033,0-5.5,2.468-5.5,5.5S12.967,21,16,21s5.5-2.468,5.5-5.5S19.033,10,16,10z M16,19
                            c-1.93,0-3.5-1.57-3.5-3.5S14.07,12,16,12s3.5,1.57,3.5,3.5S17.93,19,16,19z"/>
                        <circle fill={color} cx="16" cy="15.5" r="2" />
                    </g>
                </svg>
            )
        }

        const downloadSVG = () => {
            // assets/images/LMH_SVG/dark-grey/LMH_Icons_download_dg.svg'
            return (
                <svg width={width} height={height} viewBox="0 0 32 32">
                    <g id="download">
                        <polygon fill={color} points="27,23 27,27 5,27 5,23 3,23 3,29 29,29 29,23 	" />
                        <polygon fill={color} points="24.707,14.707 23.293,13.293 17,19.586 17,3 15,3 15,19.586 8.707,13.293 7.293,14.707 16,23.5" />
                    </g>
                </svg>
            )
        }

        const dummySVG = () => {
            return (
                <svg width={width} height={height} viewBox="0 0 32 32">
                </svg>
            )
        }

        switch (type) {
            case 'settings': return settingsSVG();
            case 'search': return searchSVG();
            case 'world': return worldSVG();
            case 'share': return shareSVG();
            case 'delete': return deleteSVG();
            case 'video': return videoSVG();
            case 'euro': return euroSVG();
            case 'open': return openSVG();
            case 'star_filled': return starFilledSVG();
            case 'star_spikes': return starSpikesSVG();
            case 'load_height': return loadHeightSVG();
            case 'load_capacity': return loadCapacitySVG();
            case 'edit': return editSVG();
            case 'edit2': return edit2SVG();
            case 'close': return closeSVG();
            case 'close2': return close2SVG();
            case 'filter': return filterSVG();
            case 'person': return personSVG();
            case 'left': return leftSVG();
            case 'view': return viewSVG();
            case 'dummy': return dummySVG();
            case 'download': return downloadSVG();
            default: return null;
        }
    }

    return getImage()
}

export const IconEdit = (height, onClick) => {

    return (
        <div className="absolute top-0 right-0 p-1" onClick={onClick}>
            <Icon type='edit2' width={height * .4} height={height * .4} />
        </div>
    )
}

export const IconDelete = (height, onClick) => {

    return (
        <div className="absolute top-0 left-0 p-1" onClick={onClick}>
            <Icon type='close' width={height * .5} height={height * .5} />
        </div>
    )
}

export const IconPortfolio = (portfolio, height, onClick) => {

    if (!portfolio || typeof portfolio !== 'object') return null;

    const color = (portfolio['color']) ? portfolio.color : 'transparent';

    const style = Object.assign({ backgroundColor: color, width: (height * .4) + 'px' }, utils.getStyleHeight(height * .4, 1.0, .9, .5));

    return (
        <div className="w-full h-full flex items-center justify-center text-white" onClick={onClick}>
            <div className="flex justify-center rounded-lg border-white border-4 " style={style}>
                {portfolio['abbr']}
            </div>
        </div>
    )
}

export const FabIconDelete = (title, onClick, marginTop = 0, marginLeft = 0) => {

    const style = {
        marginTop: marginTop,
        marginLeft: marginLeft
    }

    return (
        <div className="absolute p-1" style={style}>
            <Tooltip title={title}>
                <Fab size="small" color="default" aria-label="del" onClick={onClick}><CloseIcon /></Fab>
            </Tooltip>
        </div>
    )
}

export const FabIconEdit = (title, onClick, marginTop = 0, marginLeft = 0) => {
    const style = {
        marginTop: marginTop,
        marginLeft: marginLeft
    }

    return (
        <div className="absolute p-1" style={style}>
            <Tooltip title={title}>
                <Fab size="small" color="default" aria-label="del" onClick={onClick}><EditIcon /></Fab>
            </Tooltip>
        </div>
    )
}